import React, { useEffect, useState } from "react";
import NumberComponent from "../NumberComponent";
const CountdownTimer = ({ targetTime, show }) => {
  const [remainingSeconds, setRemainingSeconds] = useState(1);

  useEffect(() => {
    const targetDate = new Date(targetTime).getTime();

    const updateTimer = () => {
      const now = new Date().getTime();
      const diff = Math.max(Math.floor((targetDate - now) / 1000), 0);
      setRemainingSeconds(diff);
    };

    updateTimer(); // بار اول
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [targetTime]);

  const minutes = String(Math.floor(remainingSeconds / 60)).padStart(2, "0");
  const seconds = String(remainingSeconds % 60).padStart(2, "0");

  useEffect(() => {
    if (minutes == "00" && seconds == "00") {
      show(false);
    }
  }, [seconds]);

  return (
    <>
      {NumberComponent(minutes)}:{NumberComponent(seconds)}
    </>
  );
};

export default CountdownTimer;
